import { FC } from "react";
import { useLocation } from "react-router-dom";
import KPIItem from "../../pages/kpiItems/KPIItems";
import Header from "./Header";

const Layout: FC<{ children: React.ReactNode }> = ({ children }) => {
    const { pathname } = useLocation();

    const hideOnRoutes = ["/login", "/signup"]; // add more if needed
    const shouldHideKPI = hideOnRoutes.includes(pathname.toLowerCase());

    return (
        <div className="relative min-h-screen pb-20 body_bgcolor_dv"> {/* Padding bottom for KPI bar */}
            {!shouldHideKPI && <div className="fixed bottom-4 left-0 right-0 flex justify-center z-50"><Header /></div>}
            {children}
            {/* {!shouldHideKPI && <div className="fixed bottom-4 left-0 right-0 flex justify-center z-50"><KPIItem /></div>} */}
        </div>
    );
};

export default Layout;
